import React, { useEffect, useState, createElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { TermsPopup } from './components/Popups/TermsPopup';
import { PrivacyPopup } from './components/Popups/PrivacyPopup';
import { ContactPopup } from './components/Popups/ContactPopup';
// Declarar tipos para Facebook Pixel
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  // Inicializar Meta Pixel inmediatamente
  useEffect(() => {
    // Asegurarnos de que se ejecuta solo una vez y lo antes posible
    const initPixel = () => {
      // Definir fbq como una función global
      window.fbq = window.fbq || function () {
        ;
        (window.fbq.q = window.fbq.q || []).push(arguments);
      };
      // Configurar fbq
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      // Cargar el script de Facebook
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Inicializar y rastrear vista de página
      window.fbq('init', '773997368965064');
      window.fbq('track', 'PageView');
      // Añadir noscript pixel
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=773997368965064&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    };
    initPixel();
    // Verificar después de 2 segundos que fbq está disponible
    setTimeout(() => {
      if (window.fbq) {
        window.fbq('track', 'PageView');
      }
    }, 2000);
  }, []);
  // Función para rastrear eventos de conversión
  const trackPurchase = () => {
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 9.97,
        currency: 'USD'
      });
    }
  };
  return <>
      <Helmet data-id="element-0">
        <title data-id="element-1">Mama Plena - Kit de Cuidado en el Postparto</title>
        <meta name="description" content="Cómo prepararte para el cuarto trimestre. Autocuidado en el postparto." data-id="element-2" />
      </Helmet>
      <div className="flex flex-col min-h-screen w-full bg-[#faf7f5]" data-id="element-3">
        <Hero data-id="element-4" />
        <Benefits data-id="element-5" />
        <Bonuses data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CallToAction onPurchaseClick={trackPurchase} data-id="element-8" />
        <Footer onTermsClick={() => setTermsOpen(true)} onPrivacyClick={() => setPrivacyOpen(true)} onContactClick={() => setContactOpen(true)} data-id="element-9" />
        <TermsPopup open={termsOpen} onOpenChange={setTermsOpen} data-id="element-10" />
        <PrivacyPopup open={privacyOpen} onOpenChange={setPrivacyOpen} data-id="element-11" />
        <ContactPopup open={contactOpen} onOpenChange={setContactOpen} data-id="element-12" />
      </div>
    </>;
}